<template>
  <b-container class="p-0">
    <b-row class="bg-dkgrey header p-0">
      <b-col class="text-dashboard-label">
        {{this.$store.state.page}}
      </b-col>
      <b-col>
        <div class="text-header">
          Logged in as {{this.$store.state.user.loggedInAs.name}}<br />
          <b-link class="link-header" :href="this.$store.state.locals.apiUrl + '/auth/logout'">Logout</b-link>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'Header',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
